import { Tooltip as ReactTooltip } from "react-tooltip";
import { classNames } from "../../helpers/classNames";

const Tooltip = ({
  value,
  position = "bottom",
  type,
  message,
  children,
  className,
  messageClass,
}) => {
  const tooltipId = `tooltip-${Math.random().toString(36).substr(2, 9)}`;
  return (
    <>
      <div
        className={classNames("w-fit h-fit", className)}
        data-tooltip-id={tooltipId}
      >
        {children ? children : value}
      </div>
      <ReactTooltip
        id={tooltipId}
        place={position}
        variant={type}
        content={message}
        className={classNames(
          "z-70 !text-[12px] !h-fit !px-3 !py-1 shadow-md !bg-primary !text-white font-normal",
          messageClass
        )}
      />
    </>
  );
};

export default Tooltip;
